export default __webpack_public_path__ + "static/media/notificationSound.2bd722b2.wav";